import React from 'react'
import PropTypes from 'prop-types'
import PersonalFields from './personal-fields'
import BillingFields from './billing-fields'
import PaymentDetailFields from './payment-details-fields'

const Fields = ({ bookingDetails, paymentOption, setPaymentOption, clientApplyCode, form, id }) => (
  <div className="flex md:flex-row flex-col">
    <div className="flex-1 lg:flex-1 sm:flex-0 mx-10">
      <h1 className="text-3xl text-primary-seafoam">Confirm and Pay</h1>
      <PersonalFields />
      <BillingFields bookingDetails={bookingDetails}
        paymentOption={paymentOption}
        setPaymentOption={setPaymentOption}
        clientApplyCode={clientApplyCode}
        form={form}
        id={id}
      />
    </div>
    <div className="flex-1 lg:flex-1 sm:flex-0 mx-10">
      <PaymentDetailFields bookingDetails={bookingDetails} />
    </div>
  </div>
)

Fields.propTypes = {
  bookingDetails: PropTypes.object,
  paymentOption: PropTypes.string.isRequired,
  setPaymentOption: PropTypes.func.isRequired,
  clientApplyCode: PropTypes.func,
  form: PropTypes.string,
  id: PropTypes.string
}

export default Fields
